export default __webpack_public_path__ + "79cd6c4353e473b797889090c912e19a.png";